function initModal() {
	// Controlla se esiste almeno un elemento con la classe "modal"
	if (!document.querySelector('.modal')) return;

	const manageModal = (target, action) => {
		if (!target || !action) return;

		const modal = document.querySelector(target);
		const htmlTag = document.documentElement;

		if (modal) {
			modal.parentElement.classList.toggle('open', action === 'open');
			htmlTag.classList.toggle("no-scroll", action === 'open');
		}
	};

	// Rendi `manageModal` accessibile globalmente
	window.manageModal = manageModal;
}

export default { initModal };
